import { render, staticRenderFns } from "./shuxinglaiyuan.vue?vue&type=template&id=2df52069&scoped=true&"
import script from "./shuxinglaiyuan.vue?vue&type=script&lang=ts&"
export * from "./shuxinglaiyuan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df52069",
  null
  
)

export default component.exports